import mitt from 'mitt'
const EventBus = mitt()
export enum IEventBus {
  RollAppBroadcast = 'RollAppBroadcast',
  ParsedMessage = 'ParsedMessage',
  WebSocketConnectShow = 'WebSocketConnectShow',
}
export default EventBus
